import { combineReducers, configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import { thunk } from 'redux-thunk';
import configReducer from './configSlice';
import userReducer from './userSlice';
import langReducer from './langSlice';

// Configuration pour redux-persist
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['lang', 'config', 'user'],
};

// Combinaison des reducers
const rootReducer = combineReducers({
  lang: langReducer,
  config: configReducer,
  user: userReducer,
});

// Application de redux-persist au rootReducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configuration du store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(thunk),
});

// Configuration du persistor
export const persistor = persistStore(store);